module.exports = __webpack_public_path__ + "static/media/budget-transfers.008faaf8.png";